module.exports = __webpack_public_path__ + "static/media/SaifeeEvents86.1c7683d9.jpg";